import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { PageLoaderService } from '../page-loader.service';

@Component({
  selector: 'ls-spinner-loader',
  template: `
    <div class="cover loader" *ngIf="(isLoading$ | async) || isLoading">
      <div class="centered">
        <div class="c-loader">
          <img src="assets/img/icons/icon-spinner-gray.svg" />
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./spinner-loader.component.scss']
})
export class SpinnerLoaderComponent {
  @Input() public isLoading: boolean = null;
  public isLoading$: Observable<boolean> = null;

  constructor(private pageLoaderService: PageLoaderService) {
    this.isLoading$ = this.pageLoaderService.pageLoading$;
  }
}
